import { Button, Modal } from 'antd';
import { useAIAgentCenterContext } from 'contexts/ai-agent-center';
import { useInterceptAICallSession } from 'hooks';
import { aiAgentCenterMessages, messages } from 'messages';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE } from 'routes/constants';

type Props = {
  callSessionId?: number;
};

const AIAgentCallIntervention: React.FC<Props> = ({ callSessionId }) => {
  const navigate = useNavigate();

  const { setCallSession } = useAIAgentCenterContext();

  const { onInterceptCallSession, isLoading } = useInterceptAICallSession();

  const handleIntervention = () => {
    Modal.confirm({
      title: aiAgentCenterMessages.interventionCall,
      content: aiAgentCenterMessages.interventionCallWarning,
      okText: messages.confirmButtonText,
      cancelText: messages.cancelButtonText,
      onOk: () => {
        if (callSessionId) {
          onInterceptCallSession(callSessionId, (data) => {
            if (data.callSessionId) {
              navigateSupportCustomer(data.callSessionId);
            }
            setCallSession(null);
          });
        }
      },
      okButtonProps: {
        loading: isLoading
      }
    });
  };

  const navigateSupportCustomer = (callSessionId: number) => {
    navigate(ROUTE.CUSTOMER_LOOKUP, {});
  };

  return (
    <>
      <Button
        loading={isLoading}
        className='h-10 w-[105px] font-semibold'
        danger
        onClick={() => {
          handleIntervention();
        }}
      >
        {aiAgentCenterMessages.intervention}
      </Button>
    </>
  );
};
export default AIAgentCallIntervention;
